import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import AttachFileOutlinedIcon from "@mui/icons-material/AttachFileOutlined";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";

interface UserActionsV2Props {
  type: "direct" | "group" | "channel" | "project";
  groupId: string;
  onOpenDrawer: (type: string) => void;
}

const iconSx = {
  color: "#9AA0AC",
  "&:hover": { color: "#1A1F2E" },
};

const UserActionsV2: React.FC<UserActionsV2Props> = ({ onOpenDrawer }) => {
  return (
    <>
      <Tooltip title="Files">
        <IconButton size="small" aria-label="View files" sx={iconSx} onClick={() => onOpenDrawer("files")}>
          <AttachFileOutlinedIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Tooltip title="Members">
        <IconButton size="small" aria-label="View members" sx={iconSx} onClick={() => onOpenDrawer("users")}>
          <PeopleOutlineIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </>
  );
};

export default UserActionsV2;
